import { gql } from "@apollo/client";

export const SAVE_ANSWER_DRAFT = gql`
  mutation (
    $assignmentQuestion: ID!
    $student: ID!
    $tokenUser: ID
    $token: String
    $answer: String!
    $answerDocument: GenericScalar
    $expectedRevision: Int!
  ) {
    saveAnswerDraft(
      assignmentQuestion: $assignmentQuestion
      student: $student
      tokenUser: $tokenUser
      token: $token
      answer: $answer
      answerDocument: $answerDocument
      expectedRevision: $expectedRevision
    ) {
      success
      message
      conflict
      draft {
        answer
        answerDocument
        savedAt
        revision
      }
    }
  }
`;

// TODO: need to update all references to identifiers to be either a student or student identifier
// TODO: need to update all input references that have identifier to have student as optional / flag

export const CREATE_ASSIGNMENT_MUTATION = gql`
  mutation CreateAssignment(
    $assignment: ID
    $name: String!
    $questions: [ID]!
    $schoolClass: ID!
    $dueDate: String!
    $createAssignmentGroup: Boolean
    $groupName: String
  ) {
    createAssignment(
      assignment: $assignment
      name: $name
      questions: $questions
      schoolClass: $schoolClass
      dueDate: $dueDate
      createAssignmentGroup: $createAssignmentGroup
      groupName: $groupName
    ) {
      success
      message
      assignment {
        id
        preferences {
          id
          data
        }
      }
      assignmentGroup {
        id
        name
      }
    }
  }
`;

export const QUICK_START_DEMO_SUBMIT = gql`
  mutation QuickStartDemoSubmit(
    $schoolClass: ID
    $schoolClassName: String
    $student: ID
    $studentName: String
    $assignmentName: String!
    $questionText: String!
    $sourceExtract: String
    $chosenObjectives: JSONString!
    $answerText: String
    $yearGroup: ID!
    $subject: ID!
    $temporaryImages: [ID]
    $handwrittenImageFile: Upload
  ) {
    quickStartDemoSubmit(
      schoolClass: $schoolClass
      schoolClassName: $schoolClassName
      student: $student
      studentName: $studentName
      assignmentName: $assignmentName
      questionText: $questionText
      sourceExtract: $sourceExtract
      chosenObjectives: $chosenObjectives
      answerText: $answerText
      yearGroup: $yearGroup
      subject: $subject
      temporaryImages: $temporaryImages
      handwrittenImageFile: $handwrittenImageFile
    ) {
      success
      message
      assignment {
        id
      }
    }
  }
`;

export const GENERATE_ASSIGNMENT_MUTATION = gql`
  mutation GenerateAssignment(
    $name: String!
    $files: [Upload]!
    $schoolClass: ID!
    $subject: ID
    $dueDate: String!
    $includesMarkScheme: Boolean
    $singleQuestion: Boolean
  ) {
    generateAssignment(
      name: $name
      files: $files
      schoolClass: $schoolClass
      subject: $subject
      dueDate: $dueDate
      includesMarkScheme: $includesMarkScheme
      singleQuestion: $singleQuestion
    ) {
      success
      message
      assignment {
        id
      }
    }
  }
`;

export const DELETE_ASSIGNMENT_MUTATION = gql`
  mutation DeleteAssignment($assignment: ID!) {
    deleteAssignment(assignment: $assignment) {
      success
      message
    }
  }
`;

export const PUBLISH_ASSIGNMENT = gql`
  mutation publishAssignment($assignment: ID!) {
    publishAssignment(assignment: $assignment) {
      success
      message
    }
  }
`;
export const CREATE_ASSIGNMENT_FROM_TEMPLATE_MUTATION = gql`
  mutation CreateAssignment(
    $name: String!
    $assignmentTemplate: ID!
    $schoolClasses: [ID]!
    $dueDate: String!
    $createAssignmentGroup: Boolean
  ) {
    createAssignmentFromTemplate(
      name: $name
      assignmentTemplate: $assignmentTemplate
      schoolClasses: $schoolClasses
      dueDate: $dueDate
      createAssignmentGroup: $createAssignmentGroup
    ) {
      success
      message
      assignments {
        id
      }
    }
  }
`;

export const SUBMIT_ANSWER_MUTATION = gql`
  mutation SubmitAnswer(
    $assignmentQuestion: ID!
    $student: ID!
    $answer: String!
    $answerDocument: GenericScalar
    $draftRevision: Int
    $tokenUser: ID
    $token: String
    $appendToExisting: Boolean
    $isIndependent: Boolean
  ) {
    submitAnswer(
      assignmentQuestion: $assignmentQuestion
      student: $student
      answer: $answer
      answerDocument: $answerDocument
      draftRevision: $draftRevision
      tokenUser: $tokenUser
      token: $token
      appendToExisting: $appendToExisting
      isIndependent: $isIndependent
    ) {
      success
      message
      conflict
      draftRevision
    }
  }
`;
export const CREATE_SINGLE_FEEDBACK_AS_PDF_MUTATION = gql`
  mutation ($assignment: ID!, $student: ID!) {
    studentFeedbackAsPdf(assignment: $assignment, student: $student) {
      success
      message
      job {
        id
      }
    }
  }
`;

export const RECORD_ANSWER_VIEW = gql`
  mutation ($answer: ID!) {
    recordAnswerView(answer: $answer) {
      success
      message
    }
  }
`;
export const CREATE_ALL_FEEDBACK_AS_PDF_MUTATION = gql`
  mutation ($assignment: ID!) {
    allFeedbackAsPdf(assignment: $assignment) {
      success
      message
      job {
        id
      }
    }
  }
`;
export const CREATE_ASSIGNMENT_AS_PDF_MUTATION = gql`
  mutation ($assignment: ID!) {
    assignmentAsPdf(assignment: $assignment) {
      success
      message
      job {
        id
      }
    }
  }
`;

export const CREATE_COVER_SHEETS_MUTATION = gql`
  mutation ($assignment: ID!) {
    coverSheetsAsPdf(assignment: $assignment) {
      success
      message
      job {
        id
      }
    }
  }
`;

export const EXPORT_ASSSIGNMENT_RESULTS_MUTATION = gql`
  mutation ($assignment: ID!) {
    exportAssignmentResultsToCsv(assignment: $assignment) {
      success
      message
      job {
        id
      }
    }
  }
`;

export const EXPORT_ASSIGNMENT_GROUP_RESULTS_MUTATION = gql`
  mutation ($assignmentGroup: ID!, $schools: [ID]) {
    exportAssignmentGroupResultsToCsv(
      assignmentGroup: $assignmentGroup
      schools: $schools
    ) {
      success
      message
      job {
        id
      }
    }
  }
`;

export const SUBMIT_MULTI_STUDENT_FILE = gql`
  mutation ($assignment: ID!, $file: Upload!) {
    submitMultiStudentAssignmentFile(assignment: $assignment, file: $file) {
      success
      message
      job {
        id
        status
        progress
      }
    }
  }
`;

export const SUBMIT_ASSIGNMENT_GROUP_FILE = gql`
  mutation ($assignmentGroup: ID!, $file: Upload!) {
    submitAssignmentGroupFile(assignmentGroup: $assignmentGroup, file: $file) {
      success
      message
      job {
        id
        status
        progress
      }
    }
  }
`;

export const CREATE_ASSIGNMENT_GROUP_COVER_SHEETS = gql`
  mutation ($assignmentGroup: ID!) {
    assignmentGroupCoverSheetsAsPdf(assignmentGroup: $assignmentGroup) {
      success
      message
      job {
        id
        status
        progress
      }
    }
  }
`;

export const SUBMIT_HANDWRITTEN_PDF_MUTATION = gql`
  mutation submitHandwrittenPdf(
    $assignmentQuestion: ID!
    $pdfFile: Upload!
    $student: ID!
    $markOnSubmit: Boolean!
  ) {
    submitHandwrittenPdf(
      assignmentQuestion: $assignmentQuestion
      pdfFile: $pdfFile
      student: $student
      markOnSubmit: $markOnSubmit
    ) {
      success
      message
    }
  }
`;

export const GENERATE_UPLOAD_URL = gql`
  mutation ($assignment: ID, $assignmentQuestion: ID, $studentDirect: Boolean) {
    generateUploadUrl(
      assignment: $assignment
      assignmentQuestion: $assignmentQuestion
      studentDirect: $studentDirect
    ) {
      success
      message
      url
    }
  }
`;

export const VERIFY_UPLOAD_TOKEN = gql`
  mutation (
    $user: ID!
    $token: String!
    $assignment: ID
    $assignmentQuestion: ID
    $studentCreatedToken: Boolean
  ) {
    verifyUploadToken(
      user: $user
      token: $token
      assignment: $assignment
      assignmentQuestion: $assignmentQuestion
      studentCreatedToken: $studentCreatedToken
    ) {
      success
      message
      isValid
      studentInputSettings
      students {
        id
        identifier
      }
      answers {
        student {
          id
          pseudonymisedAt
          identifier
        }
      }
    }
  }
`;

export const SUBMIT_UPLOADED_IMAGES = gql`
  mutation (
    $user: ID!
    $assignment: ID
    $assignmentQuestion: ID
    $token: String!
    $images: [Upload]!
    $student: ID!
  ) {
    submitUploadedImages(
      user: $user
      assignment: $assignment
      assignmentQuestion: $assignmentQuestion
      token: $token
      images: $images
      student: $student
    ) {
      success
      message
      students {
        id
        identifier
      }
      answers {
        student {
          id
          pseudonymisedAt
          identifier
        }
      }
    }
  }
`;

export const UPDATE_ASSESSMENT_OBJECTIVE_FEEDBACK_MARK_MUTATION = gql`
  mutation ($assessmentObjectiveFeedback: ID!, $mark: Int!) {
    updateAssessmentObjectiveFeedbackMark(
      assessmentObjectiveFeedback: $assessmentObjectiveFeedback
      mark: $mark
    ) {
      success
      message
      assessmentObjectiveFeedback {
        id
        mark
        availableMarks
        assessmentObjectiveEvidence {
          id
          evidence
          reasoning
          feedback
          locations {
            startIndex
            endIndex
          }
        }
        assessmentObjective {
          id
          identifier
          focusArea
        }
      }
    }
  }
`;

export const UPDATE_FEEDBACK_EVIDENCE_MUTATION = gql`
  mutation (
    $evidence: ID!
    $reasoning: String!
    $howToImprove: String!
    $isDelete: Boolean
  ) {
    updateFeedbackEvidence(
      evidence: $evidence
      reasoning: $reasoning
      howToImprove: $howToImprove
      isDelete: $isDelete
    ) {
      success
      message
      evidence {
        id
        evidence
        reasoning
        feedback
        locations {
          startIndex
          endIndex
        }
      }
    }
  }
`;
export const CREATE_FEEDBACK_EVIDENCE_MUTATION = gql`
  mutation (
    $assessmentObjectiveFeedback: ID!
    $reasoning: String!
    $howToImprove: String!
    $example: String!
    $startIndex: Int
    $endIndex: Int
  ) {
    createFeedbackEvidence(
      assessmentObjectiveFeedback: $assessmentObjectiveFeedback
      reasoning: $reasoning
      howToImprove: $howToImprove
      example: $example
      startIndex: $startIndex
      endIndex: $endIndex
    ) {
      success
      message
      evidence {
        id
        evidence
        reasoning
        feedback
        locations {
          startIndex
          endIndex
        }
      }
    }
  }
`;

export const CREATE_SPELLING_AND_GRAMMAR_FEEDBACK_MUTATION = gql`
  mutation (
    $feedback: ID!
    $example: String!
    $correctSpelling: String!
    $reasoning: String!
    $startIndex: Int!
    $endIndex: Int!
  ) {
    createSpellingAndGrammarFeedback(
      feedback: $feedback
      example: $example
      correctSpelling: $correctSpelling
      reasoning: $reasoning
      startIndex: $startIndex
      endIndex: $endIndex
    ) {
      success
      message
      spellingFeedback {
        id
        reasoning
        mistake {
          incorrectSpelling
          correctSpelling
        }
        locations {
          startIndex
          endIndex
        }
      }
    }
  }
`;

export const UPDATE_SPELLING_AND_GRAMMAR_FEEDBACK_MUTATION = gql`
  mutation (
    $spellingFeedback: ID!
    $correctSpelling: String!
    $reasoning: String!
    $isDelete: Boolean
  ) {
    updateSpellingAndGrammarFeedback(
      spellingFeedback: $spellingFeedback
      correctSpelling: $correctSpelling
      reasoning: $reasoning
      isDelete: $isDelete
    ) {
      success
      message
      spellingFeedback {
        id
        reasoning
        mistake {
          incorrectSpelling
          correctSpelling
        }
        locations {
          startIndex
          endIndex
        }
      }
    }
  }
`;

export const UPDATE_TEACHER_FEEDBACK_MUTATION = gql`
  mutation (
    $feedback: ID!
    $areasToImprove: String
    $specificFeedback: String
  ) {
    updateTeacherFeedback(
      feedback: $feedback
      areasToImprove: $areasToImprove
      specificFeedback: $specificFeedback
    ) {
      success
      message
      feedback {
        id
        mark
        specificAreasOfImprovement
        feedback
        assessmentObjectiveFeedback {
          id
          mark
          assessmentObjectiveEvidence {
            id
            evidence
            reasoning
            feedback
            locations {
              startIndex
              endIndex
            }
          }
          assessmentObjective {
            id
            identifier
            focusArea
          }
        }
      }
    }
  }
`;
export const UPDATE_OVERALL_FEEDBACK_MUTATION = gql`
  mutation (
    $assignmentQuestionFeedback: ID
    $assignmentFeedback: ID
    $areasToImprove: String
    $specificFeedback: String
  ) {
    updateOverallFeedback(
      assignmentQuestionFeedback: $assignmentQuestionFeedback
      assignmentFeedback: $assignmentFeedback
      areasToImprove: $areasToImprove
      specificFeedback: $specificFeedback
    ) {
      success
      message
      feedback {
        ... on AssignmentFeedbackNode {
          id
          specificAreasOfImprovement
          feedback
          lastUpdated
          allowGenerate
          misconceptions {
            id
            misconception
            correction
          }
          knowledgeGaps {
            id
            knowledgeGap
          }
        }
        ... on AssignmentQuestionFeedbackNode {
          id
          specificAreasOfImprovement
          feedback
          lastUpdated
          allowGenerate
          misconceptions {
            id
            misconception
            correction
          }
          knowledgeGaps {
            id
            knowledgeGap
          }
        }
      }
    }
  }
`;
export const GENERATE_OVERALL_FEEDBACK_MUTATION = gql`
  mutation ($assignmentQuestionFeedback: ID, $assignmentFeedback: ID) {
    generateOverallFeedback(
      assignmentQuestionFeedback: $assignmentQuestionFeedback
      assignmentFeedback: $assignmentFeedback
    ) {
      success
      message
      job {
        id
        message
      }
    }
  }
`;

export const RETRY_ANSWER_EXTRACTION_MUTATION = gql`
  mutation RetryAnswerExtraction($answer: ID!) {
    retryAnswerExtraction(answer: $answer) {
      success
      message
    }
  }
`;

export const RETRY_BULK_FILE_UPLOAD_MUTATION = gql`
  mutation RetryBulkFileUpload($bulkFileUpload: ID!) {
    retryBulkFileUpload(bulkFileUpload: $bulkFileUpload) {
      success
      message
    }
  }
`;

export const APPROVE_ANSWER_FEEDBACK_MUTATION = gql`
  mutation ApproveAnswerFeedback($answer: ID!, $approved: Boolean!) {
    approveAnswerFeedback(answer: $answer, approved: $approved) {
      success
      message
    }
  }
`;

export const APPROVE_EXTRACTION_MUTATION = gql`
  mutation ApproveExtraction($handwrittenFile: ID!) {
    approveExtraction(handwrittenFile: $handwrittenFile) {
      success
      message
      handwrittenFile {
        id
        extractionQualityReview {
          reviewSuggested
          qualityLevel
          qualityReason
        }
      }
    }
  }
`;

export const RELEASE_FEEDBACK_MUTATION = gql`
  mutation ReleaseFeedback($assignment: ID!) {
    releaseFeedback(assignment: $assignment) {
      success
      message
    }
  }
`;

export const UPDATE_ASSIGNMENT_MUTATION = gql`
  mutation UpdateAssignment(
    $assignment: ID!
    $dueDate: String!
    $tags: [String!]!
  ) {
    updateAssignment(assignment: $assignment, dueDate: $dueDate, tags: $tags) {
      success
      message
    }
  }
`;
export const REMOVE_QUESTION_FROM_ASSIGNMENT_MUTATION = gql`
  mutation removeQuestionFromAssignment($assignment: ID!, $question: ID!) {
    removeQuestionFromAssignment(assignment: $assignment, question: $question) {
      success
      message
    }
  }
`;

export const SUBMIT_ASSIGNMENT_FILES = gql`
  mutation (
    $assignment: ID!
    $files: [Upload]!
    $student: ID!
    $user: ID
    $token: String
  ) {
    submitAssignmentFiles(
      assignment: $assignment
      files: $files
      student: $student
      user: $user
      token: $token
    ) {
      success
      message
      job {
        id
        status
        progress
        message
      }
      students {
        id
        firstName
        lastName
        identifier
      }
      answers {
        id
      }
    }
  }
`;

export const CLEAR_CONSOLIDATED_ITEMS_MUTATION = gql`
  mutation ClearConsolidatedItems($jobId: ID!) {
    clearConsolidatedItems(jobId: $jobId) {
      success
      message
    }
  }
`;

export const REVIEW_QUESTION_PAGE_MAPPINGS_MUTATION = gql`
  mutation ReviewQuestionPageMappings(
    $fileProcessingResult: ID!
    $mappings: [ReviewedQuestionPageMappingInput!]!
  ) {
    reviewQuestionPageMappings(
      fileProcessingResult: $fileProcessingResult
      mappings: $mappings
    ) {
      success
      message
    }
  }
`;

export const RETRY_FAILED_UPLOAD_JOB = gql`
  mutation ($fileProcessingResultId: ID!) {
    retryFailedUploadJob(fileProcessingResultId: $fileProcessingResultId) {
      success
      message
      job {
        id
        status
      }
    }
  }
`;

export const UPDATE_ASSIGNMENT_PREFERENCES_MUTATION = gql`
  mutation ($assignment: ID!, $prefs: GenericScalar!) {
    updateAssignmentPreferences(assignment: $assignment, prefs: $prefs) {
      success
      message
    }
  }
`;

export const UPDATE_HOLISTIC_MARK_FOR_ANSWER_MUTATION = gql`
  mutation ($answer: ID!, $mark: Int!) {
    updateHolisticMarkForAnswer(answer: $answer, mark: $mark) {
      success
      message
      newAoMarks
    }
  }
`;

export const UPDATE_MISCONCEPTIONS_AND_KNOWLEDGE_GAPS_MUTATION = gql`
  mutation (
    $feedback: ID
    $assignmentQuestionFeedback: ID
    $assignmentFeedback: ID
    $misconceptions: [String]
    $knowledgeGaps: [String]
  ) {
    updateMisconceptionsAndKnowledgeGaps(
      feedback: $feedback
      assignmentQuestionFeedback: $assignmentQuestionFeedback
      assignmentFeedback: $assignmentFeedback
      misconceptions: $misconceptions
      knowledgeGaps: $knowledgeGaps
    ) {
      success
      message
    }
  }
`;

export const CREATE_ASSIGNMENT_GROUP_MUTATION = gql`
  mutation CreateAssignmentGroup($name: String!, $assignment: ID!) {
    createAssignmentGroup(name: $name, assignment: $assignment) {
      success
      message
      assignmentGroup {
        id
        name
      }
    }
  }
`;

export const ADD_CLASSES_TO_GROUP_MUTATION = gql`
  mutation AddClassesToGroup($assignmentGroup: ID!, $schoolClasses: [ID]!) {
    addClassesToGroup(
      assignmentGroup: $assignmentGroup
      schoolClasses: $schoolClasses
    ) {
      success
      message
      createdCount
      linkedCount
      assignmentGroup {
        id
        name
      }
    }
  }
`;
